<stepper-manage-contact-list
[securityStateObject]="securityStateObject"
[currentuserId]="currentuserId"
[data]="data"
[stepperType]="'linked_passwords'"
[manageType]="'password'"
(parentFun)="parentFun($event)"
[parent_vault_user_form_id]="data.vault_user_form_id"
>

</stepper-manage-contact-list>